export default __webpack_public_path__ + "static/gmail-addon-store-email-9cedf615469b39db653be2ed193818f1.mp4";